<div id="nonogram-page">
    <div id="nonogram-container">
        <div class="left column"></div>
        <div class="center column"></div>
        <div class="right column"></div>
    </div>
</div>